import Translation from "components/Translation"
import { classNames } from "utils/dom-helpers"
import InputSpinner from "./input"

export enum SavingStatus {
    NONE,
    SAVING,
    SAVED_SUCCESS,
    SAVED_FAILURE
}

export function SavingStates({
    status = SavingStatus.NONE,
    className = '',
    innerClassName = ''
}: {
    status: SavingStatus
    className?: string
    innerClassName?: string
}) {
    return (
        <div className={classNames(className, 'mt-2')}>
            {status == SavingStatus.SAVING && (
                <>
                    <InputSpinner svg_class_name={classNames("h-6 w-6", innerClassName ? "" : "-mt-3")} className={innerClassName ? "my-auto" : ""} />
                    <Translation render_as="span" className={innerClassName} content_key='saving_changes' />
                </>
            )}
            {status == SavingStatus.SAVED_SUCCESS && (
                <>
                    <i className="feather-check-circle text-green-400 text-lg mr-2" />
                    <Translation render_as="span" className={innerClassName} content_key='saved_success' />
                </>
            )}
            {status == SavingStatus.SAVED_FAILURE && (
                <>
                    <i className="feather-alert-circle text-red-400 text-lg mr-2" />
                    <Translation render_as='span' className='text-red-400' content_key='saved_failure' />
                </>
            )}
        </div>
    )
}

export default SavingStates